import * as React from 'react';
import { IconProps } from '../types';

const IcInStore = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      fill={props?.fill ?? '#232F3E'}
      d="M21.28 13.24V20h1v2h-20v-2h1v-6.76a4.35 4.35 0 0 1-1.47-1.62 4.463 4.463 0 0 1-.53-2.12c0-.84.213-1.607.64-2.3l2.7-4.7A.985.985 0 0 1 5.5 2h13.58a.986.986 0 0 1 .86.5l2.7 4.68c.4.68.613 1.407.64 2.18a4.38 4.38 0 0 1-.49 2.19 4.484 4.484 0 0 1-1.51 1.69Zm-2 .74a4.677 4.677 0 0 1-2.03-.25 4.294 4.294 0 0 1-1.71-1.11c-.427.44-.923.78-1.49 1.02s-1.157.36-1.77.36c-.614 0-1.204-.12-1.77-.36a4.286 4.286 0 0 1-1.47-1.02c-.494.507-1.07.88-1.73 1.12-.66.24-1.337.32-2.03.24V20h14v-6.02ZM6.06 4 3.64 8.22a2.36 2.36 0 0 0-.03 1.82 2.4 2.4 0 0 0 1.23 1.35c.586.287 1.193.34 1.82.16a2.369 2.369 0 0 0 1.44-1.13.936.936 0 0 1 .54-.55c.253-.1.51-.1.77 0s.443.283.55.55c.186.48.493.863.92 1.15.426.287.893.43 1.4.43.507 0 .973-.143 1.4-.43.427-.287.733-.67.92-1.15a.936.936 0 0 1 .54-.55c.253-.1.51-.1.77 0s.443.283.55.55c.173.44.45.8.83 1.08.38.28.803.44 1.27.48.466.04.91-.047 1.33-.26.42-.213.753-.517 1-.91s.373-.827.38-1.3a2.43 2.43 0 0 0-.35-1.31L18.5 4H6.06Z"
    />
  </svg>
);

export default IcInStore;